module.exports = __webpack_public_path__ + "static/img/productBottom.d2ffebe.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/productBottom.png
// module id = ERxM
// module chunks = 1